const CHART_CONTAINER_CLASSES =
  'm-3 p-6 border border-muted rounded-3xl h-full min-h-0 flex flex-col';

// Tailwind needs to see concrete class strings to generate them.
// We provide explicit mappings for grid positions/spans (12 columns; ample row spans).
const COL_START = [
  'col-start-1',
  'col-start-2',
  'col-start-3',
  'col-start-4',
  'col-start-5',
  'col-start-6',
  'col-start-7',
  'col-start-8',
  'col-start-9',
  'col-start-10',
  'col-start-11',
  'col-start-12',
] as const;

const COL_SPAN = [
  'col-span-1',
  'col-span-2',
  'col-span-3',
  'col-span-4',
  'col-span-5',
  'col-span-6',
  'col-span-7',
  'col-span-8',
  'col-span-9',
  'col-span-10',
  'col-span-11',
  'col-span-12',
] as const;

// Support up to 30 rows of height for snapshots
const ROW_START = [
  'row-start-1',
  'row-start-2',
  'row-start-3',
  'row-start-4',
  'row-start-5',
  'row-start-6',
  'row-start-7',
  'row-start-8',
  'row-start-9',
  'row-start-10',
  'row-start-11',
  'row-start-12',
  'row-start-13',
  'row-start-14',
  'row-start-15',
  'row-start-16',
  'row-start-17',
  'row-start-18',
  'row-start-19',
  'row-start-20',
  'row-start-21',
  'row-start-22',
  'row-start-23',
  'row-start-24',
  'row-start-25',
  'row-start-26',
  'row-start-27',
  'row-start-28',
  'row-start-29',
  'row-start-30',
] as const;

const ROW_SPAN = [
  'row-span-1',
  'row-span-2',
  'row-span-3',
  'row-span-4',
  'row-span-5',
  'row-span-6',
  'row-span-7',
  'row-span-8',
  'row-span-9',
  'row-span-10',
  'row-span-11',
  'row-span-12',
  'row-span-13',
  'row-span-14',
  'row-span-15',
  'row-span-16',
  'row-span-17',
  'row-span-18',
  'row-span-19',
  'row-span-20',
  'row-span-21',
  'row-span-22',
  'row-span-23',
  'row-span-24',
  'row-span-25',
  'row-span-26',
  'row-span-27',
  'row-span-28',
  'row-span-29',
  'row-span-30',
] as const;

const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max);
};

const colStartFor = (xZeroBased: number) => {
  const oneBased = clamp(xZeroBased + 1, 1, COL_START.length);
  return COL_START[oneBased - 1];
};

const rowStartFor = (yZeroBased: number) => {
  const oneBased = clamp(yZeroBased + 1, 1, ROW_START.length);
  return ROW_START[oneBased - 1];
};

const colSpanFor = (width: number) => {
  const w = clamp(width, 1, COL_SPAN.length);
  return COL_SPAN[w - 1];
};

const rowSpanFor = (height: number) => {
  const h = clamp(height, 1, ROW_SPAN.length);
  return ROW_SPAN[h - 1];
};

export const getGridClasses = (
  xZeroBased: number,
  yZeroBased: number,
  width: number,
  height: number,
) => {
  return `${colStartFor(xZeroBased)} ${colSpanFor(width)} ${rowStartFor(yZeroBased)} ${rowSpanFor(height)} ${CHART_CONTAINER_CLASSES}`;
};

export const getGridClassesWithConstraints = (
  xZeroBased: number,
  yZeroBased: number,
  width: number,
  height: number,
  minWidth: number,
  minHeight: number,
) => {
  const constrainedWidth = Math.max(width, minWidth);
  const constrainedHeight = Math.max(height, minHeight);

  return `${colStartFor(xZeroBased)} ${colSpanFor(constrainedWidth)} ${rowStartFor(yZeroBased)} ${rowSpanFor(constrainedHeight)} ${CHART_CONTAINER_CLASSES}`;
};
